const ALL_SUPPORTED_ROLES = ['EDITOR', 'VIEWER'];
export const SHARE_PERMISSIONS = {
  INVITE_USERS: 'invite_users',
  ASSIGN_EDITOR_ROLE: 'assign_editor_role',
  CHANGE_ROLES: 'change_roles',
  REMOVE_USERS: 'remove_users'
};
const ROLE_PERMISSIONS = {
  ADMIN: new Set([SHARE_PERMISSIONS.INVITE_USERS, SHARE_PERMISSIONS.ASSIGN_EDITOR_ROLE, SHARE_PERMISSIONS.CHANGE_ROLES, SHARE_PERMISSIONS.REMOVE_USERS]),
  EDITOR: new Set([SHARE_PERMISSIONS.INVITE_USERS, SHARE_PERMISSIONS.ASSIGN_EDITOR_ROLE]),
  VIEWER: new Set([])
};
export function hasSharePermission(portalUserRole, permission) {
  var _ROLE_PERMISSIONS$por, _ROLE_PERMISSIONS$por2;
  if (!portalUserRole || typeof portalUserRole !== 'string') return false;
  return (_ROLE_PERMISSIONS$por = (_ROLE_PERMISSIONS$por2 = ROLE_PERMISSIONS[portalUserRole]) === null || _ROLE_PERMISSIONS$por2 === void 0 ? void 0 : _ROLE_PERMISSIONS$por2.has(permission)) !== null && _ROLE_PERMISSIONS$por !== void 0 ? _ROLE_PERMISSIONS$por : false;
}
export function canInviteUsers(portalUserRole) {
  return hasSharePermission(portalUserRole, SHARE_PERMISSIONS.INVITE_USERS);
}
export function canAssignEditorRole(portalUserRole) {
  return hasSharePermission(portalUserRole, SHARE_PERMISSIONS.ASSIGN_EDITOR_ROLE);
}
export function canChangeRoles(portalUserRole) {
  return hasSharePermission(portalUserRole, SHARE_PERMISSIONS.CHANGE_ROLES);
}
export function canRemoveUsers(portalUserRole) {
  return hasSharePermission(portalUserRole, SHARE_PERMISSIONS.REMOVE_USERS);
}
export function getAssignableUserRoles(portalUserRole) {
  if (canAssignEditorRole(portalUserRole)) {
    return ALL_SUPPORTED_ROLES;
  }
  return ['VIEWER'];
}
export function getAllSupportedRoles() {
  return ALL_SUPPORTED_ROLES;
}
export function getDefaultUserRole() {
  return 'VIEWER';
}
export function toDisplayRole(value) {
  return value === 'EDITOR' ? 'EDITOR' : 'VIEWER';
}